"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkRFLXY7W2js = require('./chunk-RFLXY7W2.js');var _chunkO7R3VTO7js = require('./chunk-O7R3VTO7.js');var _chunkB6MCDPORjs = require('./chunk-B6MCDPOR.js');var _chunkUE6IS67Fjs = require('./chunk-UE6IS67F.js');var _react = require('react');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react3 = require('@emotion/react');var _jsxruntime = require('react/jsx-runtime');var x=_styled2.default.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  max-width: 0;
  position: fixed;
  overflow: hidden;
  z-index: 1000;

  &.open {
    overflow: auto;
    max-width: 100vw;
  }
`,A=e=>e==="left"?"translateX(-100%)":e==="right"?"translateX(100%)":e==="top"?"translateY(-100%)":"translateY(100%)",k=e=>e==="left"?_react3.css`
      left: 0;
      top: 0;
      bottom: 0;
    `:e==="right"?_react3.css`
      right: 0;
      top: 0;
      bottom: 0;
    `:e==="bottom"?_react3.css`
      right: 0;
      left: 0;
      bottom: 0;
      top: auto;
      height: auto;
    `:_react3.css`
    right: 0;
    left: 0;
    top: 0;
    bottom: auto;
    height: auto;
  `,s=(e,o)=>o==="desktop"&&(e==="left"||e==="right")?"60vw":o==="tablet"&&(e==="left"||e==="right")?"75vw":"100vw",q=_styled2.default.div`
  height: 100%;
  overflow: hidden;
  position: fixed;
  color: ${e=>e.theme.palette.PRIMARY};
  background: ${e=>e.theme.palette.BASE_ONE};
  opacity: 0;
  transform: ${e=>A(e.$anchor)};
  transition: 0.35s ease-out;
  ${e=>k(e.$anchor)}
  z-index: 1000;

  &.open {
    min-width: ${e=>e.theme.measurements.shape(75)};
    max-width: ${e=>s(e.$anchor,"desktop")};
    min-height: ${e=>e.theme.measurements.shape(75)};
    max-height: 100vh;
    transform: translateX(0) translateY(0);
    opacity: 1;
    overflow-y: auto;

    @media (max-width: ${e=>e.theme.breakpoint.tablet}) {
      max-width: ${e=>s(e.$anchor,"tablet")};
    }

    @media (max-width: ${e=>e.theme.breakpoint.mobile}) {
      max-width: ${e=>s(e.$anchor,"mobile")};
    }
  }
`,P=_styled2.default.div`
  padding: ${e=>e.theme.measurements.spacing(12)};
  display: flex;
  align-items: center;
  gap: ${e=>e.theme.measurements.spacing(5)};
`,y=_styled2.default.div`
  padding: ${e=>e.theme.measurements.spacing(12)};
  padding-top: ${e=>e.$topPadding?e.theme.measurements.spacing(12):0};
`;function N(e){let o=_react.useRef.call(void 0, null),{className:w,open:t=!1,children:g,anchor:$="right",preloadContent:b=!1,showCloseIcon:m=!0,onClose:r}=e,D=_react.useCallback.call(void 0, a=>{a.preventDefault(),a.stopPropagation(),r&&r(a)},[r]),C=_react.useCallback.call(void 0, a=>{t&&r&&r(a)},[r,t]);return _chunkUE6IS67Fjs.a.call(void 0, o,t?C:()=>{}),_chunkRFLXY7W2js.a.call(void 0, t),_jsxruntime.jsxs.call(void 0, x,{className:t?"open":"closed",children:[t?_jsxruntime.jsx.call(void 0, _chunkO7R3VTO7js.a,{}):"",_jsxruntime.jsxs.call(void 0, q,{ref:o,$open:t||!1,$anchor:$,className:`${w||""} ${t?"open":"closed"} aquilla-drawer drawer`,children:[m?_jsxruntime.jsx.call(void 0, P,{className:"aquilla-drawer-header drawer-header",children:_jsxruntime.jsx.call(void 0, "a",{href:"/",onClick:D,"aria-label":"Close Drawer",title:"Close Drawer",children:_jsxruntime.jsx.call(void 0, _chunkB6MCDPORjs.b,{height:30,width:30})})}):"",_jsxruntime.jsx.call(void 0, y,{$topPadding:!m,className:"aquilla-drawer-content drawer-content",children:b||t?g:""})]})]})}var z=N;exports.a = z;
